module.exports = __webpack_public_path__ + "img/bank-card-purple.c9ded369.png";